import { CalendarConfig } from '@wbk/calendar';

CalendarConfig.init({
  api: {
    cmsBase: process.env.VITE_CMS_BASE_URL!,
  },
  map: {
    apiKey: process.env.VITE_PUBLIC_GOOGLE_MAP_KEY!,
    mapId: process.env.VITE_PUBLIC_GOOGLE_MAP_ID!,
    defaultCenter: { lat: 21.5424743, lng: 39.2107468 },
    defaultZoom: 13,
    bounds: {
      north: 21.9,
      south: 21.1,
      east: 39.5,
      west: 39,
    },
  },
  design: {
    eventItemDate: {
      variant: 'pop',
    },
  },
});
